export interface Video {
  id: string;
  title: string;
  videoUrl: string;
  streamUrl?: string;
  thumbnailUrl: string;
  duration: string;
  views: number;
  likes: number;
  category: string;
  description: string;
  createdAt: string;
  priority?: number;
  performer?: string;
  source?: string;
  hash?: string;
}

export interface Scraper {
  id: string;
  name: string;
  url: string;
  category: string;
  clicks: number;
}

export interface Page {
  id: string;
  title: string;
  content: string;
}

export interface Settings {
  siteName: string;
  siteSlogan: string;
  bannerUrl: string;
  omnitrixFeaturedVideoId?: string;
  heroVideoId?: string;
  heroVideoStart?: number;
  heroVideoEnd?: number;
  watermarkText?: string;
  titleSuffix?: string;
  stripPhrases?: string;
  enableTitleSuffix?: boolean;
  adVideoUrl?: string;
  adLinkUrl?: string;
  adEnabled?: boolean;
  adSkipSeconds?: number;
  telegramBotToken?: string;
  telegramChatId?: string;
  telegramApiId?: string;
  telegramApiHash?: string;
  telegramAutoForward?: boolean;
  telegramBypassLimit?: boolean;
}

export function getProxiedThumbnailUrl(url?: string, title?: string, pageUrl?: string): string {
  const cleanTitle = (title || "HD Video Stream").replace(/["<>]/g, "");
  if (!url || typeof url !== 'string' || url.trim() === '' || url.includes('unsplash.com')) {
    if (pageUrl && pageUrl.includes('striptube.cc')) {
      return `/api/smart-thumb?pageUrl=${encodeURIComponent(pageUrl)}`;
    }
    const svgStr = `<svg xmlns="http://www.w3.org/2000/svg" width="640" height="360" viewBox="0 0 640 360" fill="#0f172a"><defs><linearGradient id="g" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stop-color="#0f172a"/><stop offset="100%" stop-color="#020617"/></linearGradient></defs><rect width="100%" height="100%" fill="url(#g)"/><circle cx="320" cy="150" r="38" fill="#22c55e" fill-opacity="0.25"/><polygon points="312,135 336,150 312,165" fill="#22c55e"/><text x="50%" y="78%" fill="#cbd5e1" font-family="sans-serif" font-weight="bold" font-size="15" text-anchor="middle">${cleanTitle}</text><text x="50%" y="88%" fill="#22c55e" font-family="monospace" font-weight="bold" font-size="11" text-anchor="middle">⚡ ULTRA HD STREAM</text></svg>`;
    return `data:image/svg+xml;base64,${btoa(unescape(encodeURIComponent(svgStr)))}`;
  }
  const trimmed = url.trim();
  if (
    trimmed.startsWith('data:') ||
    trimmed.startsWith('blob:') ||
    trimmed.startsWith('/api/proxy') ||
    trimmed.startsWith('/api/smart-thumb') ||
    trimmed.startsWith('http://localhost') ||
    trimmed.startsWith('https://localhost')
  ) {
    return trimmed;
  }
  if (trimmed.startsWith('http://') || trimmed.startsWith('https://') || trimmed.startsWith('//')) {
    const absolute = trimmed.startsWith('//') ? 'https:' + trimmed : trimmed;
    let proxyUrl = `/api/proxy?url=${encodeURIComponent(absolute)}&title=${encodeURIComponent(cleanTitle)}`;
    if (pageUrl && pageUrl.startsWith('http')) {
      proxyUrl += `&pageUrl=${encodeURIComponent(pageUrl)}`;
    }
    return proxyUrl;
  }
  return trimmed;
}
